export default __webpack_public_path__ + "static/media/Timer.87ebbb11.png";